import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Delete, Visibility } from '@mui/icons-material';
import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { Box, Button, Divider } from '@mui/material';

import { Resume } from '@libs/models';
import {
  DataGridV2 as DataGrid,
  DashboardPageContainer,
  ResumeForm,
  Drawer,
  DownloadResumeButton,
} from '@carcareers/components';
import { useResumeAdminSearchQuery } from '@carcareers/store';
import { RESUME_ADMIN_INDEX_COLUMNS, RESUME_ADMIN_INDEX_COLUMN_INITIAL_STATE, routes } from '@carcareers/utils';
import { FormProvider, useDrawer } from '@carcareers/contexts';
import { useResume } from '@carcareers/hooks';

export const ResumeIndex: FC = () => {
  const navigate = useNavigate();
  const searchResumes = useResumeAdminSearchQuery;
  const { setOpen } = useDrawer();
  const { deleteResume } = useResume();

  const columns = [
    ...RESUME_ADMIN_INDEX_COLUMNS,
    {
      field: 'actions',
      type: 'actions' as const,
      flex: 1,
      align: 'right' as const,
      headerAlign: 'right' as const,
      getActions: (params: GridRowParams) => [
        <DownloadResumeButton showInMenu jobseeker={params.row.jobseeker} resume={params.row} />,
        <GridActionsCellItem
          showInMenu
          key={`view-${params.row.id}`}
          label="View"
          icon={<Visibility />}
          onClick={() => {
            navigate(`/${routes.ADMIN_HOME}/${routes.ADMIN_RESUMES_VIEW.replace(':id', params.row.id.toString())}`);
          }}
        />,
        <GridActionsCellItem
          showInMenu
          key={`delete-${params.row.id}`}
          label="Delete"
          icon={<Delete color="error" />}
          onClick={() => deleteResume(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <>
      <DashboardPageContainer>
        <DataGrid<Resume>
          query={searchResumes}
          columns={columns}
          tools={
            <>
              <Button onClick={() => setOpen(true)} variant="contained" color="primary">
                Add
              </Button>
              <Divider orientation="vertical" sx={{ height: 24, ml: 1 }} />
            </>
          }
          initialState={{
            columns: {
              columnVisibilityModel: RESUME_ADMIN_INDEX_COLUMN_INITIAL_STATE,
            },
          }}
        />
      </DashboardPageContainer>
      <Drawer title="Add Resume" width={500}>
        <FormProvider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%', p: 2 }}>
            <ResumeForm />
          </Box>
        </FormProvider>
      </Drawer>
    </>
  );
};
